import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";
import WarningIcon from '@material-ui/icons/Warning';
import { styled } from "@material-ui/styles";
import { useIO, useModel } from '@type-r/react';
import { Loading } from 'lqx-react/lib/flex.js';
import { asDateTimeUTC } from "lqx-react/src/formatters.js";
import React, { useState } from 'react';
import { ActivityLogList } from '../api/activityLogList.js';

export const ActivityLog = ({ assetId }) => {
    const activeLogList = useModel(ActivityLogList);
    const [activityLogData, setActivityLogData] = useState([])

    const statusFormatter = value => value ? <IconSuccess /> : <IconWarning />;
    const [orderDirection, setOrderDirection] = React.useState<'asc' | 'desc'>('desc');

    const isReady = useIO(async () => {
        const params = { skip: 0, count: 0, assetId: `${assetId}` }
        await activeLogList.activeLogList.fetch({ params: params })
        setActivityLogData(activeLogList.activeLogList.models)
    }, [])

    const checkNullStringSort = (a, b, field) => {
        if (!a[field] && !b[field]) {
            return 0;
        }
        if (!a[field] || !b[field]) {
            return -1;
        }
        return a[field].localeCompare(b[field])
    }

    const checkNullDateSort = (a, b) => {
        if (!a.createdOn && !b.createdOn) {
            return 0;
        }

        if (!a.createdOn || !b.createdOn) {
            return -1;
        }

        return Number(new Date(b.createdOn)) - Number(new Date(a.createdOn));
    }

    const sortArray = (arr, orderBy, type: 'success' | 'event' | 'initiatedBy' | 'createdOn') => {

        if (type === 'success') {
            switch (orderBy) {
                case "asc":
                    return arr.sort(function (a, b) {
                        return (a.success === b.success) ? 0 : a.success ? -1 : 1;
                    });
                case "desc":
                    return arr.sort(function (a, b) {
                        return (a.success === b.success) ? 0 : !a.success ? -1 : 1;
                    });
            }
        }

        if (type === 'event') {
            switch (orderBy) {
                case "asc":
                    return arr.sort((a, b) => checkNullStringSort(a, b, 'event'));

                case "desc":
                    return arr.sort((a, b) => checkNullStringSort(b, a, 'event'));
            }
        }

        if (type === 'initiatedBy') {
            switch (orderBy) {
                case "asc":
                    return arr.sort((a, b) => checkNullStringSort(a, b, 'initiatedBy'));
                case "desc":
                    return arr.sort((a, b) => checkNullStringSort(b, a, 'initiatedBy'));
            }
        }

        if (type === 'createdOn') {
            switch (orderBy) {
                case "asc":
                    return arr.sort((a, b) => checkNullDateSort(a, b));
                case "desc":
                    return arr.sort((a, b) => checkNullDateSort(b, a));
            }
        }
    };

    const handleSortRequest = (type: 'success' | 'event' | 'initiatedBy' | 'createdOn') => () => {
        setActivityLogData(sortArray(activityLogData, orderDirection, type));
        setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
    };

    return (
        isReady ? activityLogData.length ? (
            <Table aria-label="simple table">
                <TableHead>
                    <TableRowStyled>
                        <HeaderCell onClick={handleSortRequest('success')} style={{ width: '40px' }}>
                            <TableSortLabel direction={orderDirection}></TableSortLabel>
                        </HeaderCell>
                        <HeaderCell onClick={handleSortRequest('event')}>
                            <TableSortLabel direction={orderDirection}>Event</TableSortLabel>
                        </HeaderCell>
                        <HeaderCell onClick={handleSortRequest('createdOn')}>
                            <TableSortLabel direction={orderDirection}>Time</TableSortLabel>
                        </HeaderCell>
                        <HeaderCell onClick={handleSortRequest('initiatedBy')}>
                            <TableSortLabel direction={orderDirection}>Initiated by</TableSortLabel>
                        </HeaderCell>
                    </TableRowStyled>
                </TableHead>
                <TableBody>
                    {activityLogData.map(i => (
                        <TableRow>
                            <RowCell align={'center'}>{statusFormatter(i.success)}</RowCell>
                            <RowCell>{i.event}</RowCell>
                            <RowCell>{asDateTimeUTC(i.createdOn)}</RowCell>
                            <RowCell>{i.initiatedBy}</RowCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        ) : (<NoItems>No Items</NoItems>) : <Loading />
    )
}

const TableRowStyled = styled(TableRow)({
    background: 'rgb(231, 242, 249)',
    borderBottom: '2px solid #F2F5F8',
    borderTop: '1px solid #F2F5F8',
})

const HeaderCell = styled(TableCell)({
    fontFamily: 'Montserrat',
    padding: '0',
    height: '28px',
    color: '#63a9dc',
    fontSize: '13px',
    lineHeight: '15px',
})

const RowCell = styled(TableCell)({
    fontFamily: 'Montserrat',
    padding: '0',
    height: '28px',
    color: '#829AB0',
    fontSize: '12px',
    lineHeight: '15px',
})

const IconSuccess = styled('div')({
    width: '10px',
    height: '10px',
    background: '#43B252',
    borderRadius: '15px',
    marginLeft: '13.5px'
});


const IconWarning = styled(WarningIcon)({
    color: '#eabc5e',
    paddingRight: '3px'
});

const NoItems = styled('div')({
    width: '100%',
    textAlign: 'center',
    padding: '10px 0 10px 0',
});